var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('MobileNav',{attrs:{"showNav":_vm.showMobileNav},on:{"hideNav":_vm.hideMobileNav}}),_vm._v(" "),_c('Header',{on:{"showMobileNav":_vm.displayMobileNav}}),_vm._v(" "),_c('main',{staticClass:"page-container"},[_c('router-view')],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dcd5958","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 